import moment from "moment/moment";

export default class UserModel {
  constructor(data) {
    // this.vacation_time = moment(data.vacation.scheduled_at).format("DD/MM/YY") || null;
    // this.illness_time = moment(data.illness.scheduled_at).format("DD/MM/YY") || null;

    this.default_times = data.default_times || null;
    // this.default_logout =
    //   data.default_times.logout !== null
    //     ? moment(data.default_times.logout).format("HH:mm")
    //     : "Not Logged out today ";

    //this.default_logout = moment(data.default_times.logout).format('HH:mm') || null;
    this.illness = data.illness || null;
    this.vacation = data.vacation || null;
    this.age = data.age || null;
    this.daily_stats = data.daily_stats || null;
    this.daily_assignments = data.daily_stats.daily_assignments || null;
    this.daily_new_leads = data.daily_stats.daily_new_leads || null;
    this.daily_bad_numbers = data.daily_stats.daily_bad_numbers || null;
    this.daily_leads = data.daily_stats.daily_leads || null;
    this.daily_na = data.daily_stats.daily_na || null;
    this.daily_ni = data.daily_stats.daily_ni || null;
    this.daily_scheduled_calls = data.daily_stats.daily_scheduled_calls || null;
    this.daily_referrals = data.daily_stats.daily_referrals || null;
    this.first_name = data.first_name || null;
    this.birthday = moment(data.birth_date).format("DD/MM/YY") || null;
    this.last_name = data.last_name || null;
    this.bank = data.user_bank_details || [];
    this.email = data.email || null;
    this.address = data.address || null;
    this.phone = data.primary_phone || null;
    this.full_name = data.full_name || null;
    this.profile_img = data.profile_img || null;
    this.id = data.id || null;
    this.email = data.email || null;
    this.attendance = data.attendance || [];
    this.client_deposits = data.client_deposits || [];
    this.leads = data.leads || [];
    this.role = data.role || null;

    if (data.campaign_stats !== null) {
      let topKeywords = data.campaign_stats.keyword.map(word => word.id);
      let topKeys = topKeywords.slice(0, 2);
      let topCountries = data.campaign_stats.country_id.map(
        country => country.id
      );
      let countries = topCountries.slice(0, 2);
      let topCampaigns = data.campaign_stats.campaign_aaid.map(
        campaign => campaign.id
      );
      let campaigns = topCampaigns.slice(0, 2);
      let campaign = {
        keyWords: topKeys,
        countries: countries,
        camps: campaigns
      };
      this.campaign_stats = campaign;
    }
    if (data.campaign_stats === null) {
      this.campaign_stats = null;
    }
  }
}
